import withAuthenticateLayout, { WithAuthenticateLayout } from '../hoc/withAuthenticateLayout'
import React from 'react'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useApiErrors } from 'core/services/suggPro/useApiErrors'
import { useNotificationsPreferenceUpdate } from '@sugg-gestion/ubidreams-react-suggpro'
import NotificationPreferenceView from 'components/views/account/notificationPreferenceView'
import { NotificationPreferenceFormState } from 'components/forms/account/notificationPreferenceForm'

interface Props extends WithAuthenticateLayout<false> {}

const Notification: React.FC<Props> = ({ restaurantOwner }) => {
    const { enqueueSnackbar } = useSnackbar()
    const { t } = useTranslation()

    const history = useHistory()

    const { displayError } = useApiErrors()
    const { updateNotificationsPreference, inProgress } = useNotificationsPreferenceUpdate()

    const handleSubmit = (values: NotificationPreferenceFormState) => {
        updateNotificationsPreference({
            ...values,
            id: restaurantOwner.notificationPreference.id,
            notification_hour: 11,
        })
            .then(() => {
                enqueueSnackbar(t('views.establishment.hours.success'), {
                    variant: 'success',
                })
            })
            .catch((error) => displayError(error))
    }

    const handlePrevious = () => {
        history.push('/account')
    }

    return (
        <NotificationPreferenceView
            onSubmit={handleSubmit}
            inProgress={inProgress}
            initialValues={{
                ...restaurantOwner.notificationPreference,
            }}
            hideNotification={false}
            hideDays={false}
            onCancel={handlePrevious}
        />
    )
}

export default withAuthenticateLayout(Notification, false)
